import { render, staticRenderFns } from "./External.vue?vue&type=template&id=fe986fa4&"
import script from "./External.vue?vue&type=script&lang=js&"
export * from "./External.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports